var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvironmentalist(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 22.23L12.58 21.81C12.88 21.6 20 16.44 20 10C20 7.87827 19.1571 5.84344 17.6569 4.34315C16.1566 2.84285 14.1217 2 12 2C9.87827 2 7.84344 2.84285 6.34315 4.34315C4.84285 5.84344 4 7.87827 4 10C4 16.44 11.12 21.6 11.42 21.81L12 22.23Z",
    fill: "#349EFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9991 11.2695C10.2741 11.2695 8.80078 11.5415 8.80078 12.6293C8.80078 13.7175 10.2649 13.9991 11.9991 13.9991C13.724 13.9991 15.1973 13.7275 15.1973 12.6393C15.1973 11.5511 13.7336 11.2695 11.9991 11.2695",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9993 10.2329C13.1743 10.2329 14.1157 9.29107 14.1157 8.11646C14.1157 6.94185 13.1743 6 11.9993 6C10.8247 6 9.88281 6.94185 9.88281 8.11646C9.88281 9.29107 10.8247 10.2329 11.9993 10.2329",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironmentalist);
export default __webpack_public_path__ + "static/media/Environmentalist.afde4113dc96cb3b27e028eaacc0f5ae.svg";
export { ForwardRef as ReactComponent };